import { IScreenPoint } from "./interface";

export class ScreenPoint implements IScreenPoint  {
    public x: number;
    public y: number;

    constructor(x: number = 0, y: number = 0) {
        this.x = x;
        this.y = y;
    }

    public set(x: number, y: number): IScreenPoint {
        this.x = x;
        this.y = y;
        return this;
    }

    public distanceTo(p: IScreenPoint): number {
        return Math.sqrt((p.x - this.x) * (p.x - this.x) + (p.y - this.y) * (p.y - this.y));
    }

    public length(): number {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }

    public copy(p: IScreenPoint): IScreenPoint {
        this.x = p.x;
        this.y = p.y;
        return this;
    }

    public multiplyScalar(s: number): IScreenPoint {
        this.x *= s;
        this.y *= s;
        return this;
    }

    public add(p: IScreenPoint): IScreenPoint {
        return new ScreenPoint(this.x + p.x, this.y + p.y);
    }

    public sub(p: IScreenPoint): IScreenPoint {
        return new ScreenPoint(this.x - p.x, this.y - p.y);
    }

    public clone(): IScreenPoint {
        return new ScreenPoint(this.x, this.y);
    }
}